







import { Component, Vue, Prop } from 'vue-property-decorator'
import Button from '@/apps/open/components/Button'

export enum EPosition {
  LEFT = 'left',
  RIGHT = 'right'
}

@Component({
  components: {
    Button
  }
})
export default class Question extends Vue {
  @Prop()
  position?: EPosition

  @Prop()
  content?: string
}
